import { Button } from '@mui/material';
import { GoogleWorkspaceIcon } from '@natomalabs/natomui/src/icons';
import { useCallback } from 'react';
import useEnvironment from '../providers/Environment';

interface GoogleLoginButtonProps {
  redirectUrl?: string | null;
}

/**
 * A button that initiates Google OAuth authentication.
 * Constructs the OAuth URL with the current org slug and optional redirect URL.
 */
export default function GoogleLoginButton({
  redirectUrl
}: GoogleLoginButtonProps) {
  const { natoma } = useEnvironment();

  const handleGoogleLogin = useCallback(() => {
    const orgSlug = window.location.hostname
      .replace(`.${natoma.rootDomain}`, '')
      .replace(natoma.rootDomain, '');
    const params = new URLSearchParams();
    if (orgSlug) params.append('orgSlug', orgSlug);
    if (redirectUrl) params.append('redirectUrl', redirectUrl);
    const queryString = params.toString();
    window.location.href = `https://api.${natoma.rootDomain}/auth/google${queryString ? `?${queryString}` : ''}`;
  }, [natoma.rootDomain, redirectUrl]);

  return (
    <Button
      fullWidth
      variant="secondary"
      startIcon={<GoogleWorkspaceIcon />}
      onClick={handleGoogleLogin}
    >
      Continue with Google
    </Button>
  );
}
